/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Origin_Feature_2Inputs */

const en_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimalist browser UI centered on Brave Shields`)
};

const id_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UI browser minimalis yang berfokus pada Brave Perisai`)
};

const ms_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UI pelayar minimalis yang tertumpu pada Perisai Brave`)
};

const ca_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IU del navegador minimalista centrada en els Escuts de Brave`)
};

const cs_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimalistické UI prohlížeče zaměřené na Štíty Brave`)
};

const da_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimalistisk browser-UI centreret omkring Brave Shields`)
};

const de_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimalistische Browser-Oberfläche mit Fokus auf Brave Shields`)
};

const et_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimalistlik brauseri kasutajaliides, mis on keskendunud Brave kaitsele`)
};

const es_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IU del navegador minimalista centrada en los Escudos de Brave`)
};

const fr_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interface minimaliste du navigateur centrée sur les boucliers Brave`)
};

const hr_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimalistički UI preglednika usredotočen na Brave Štitove`)
};

const it_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UI del browser minimalista incentrata su Protezioni Brave`)
};

const lv_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimālistisks pārlūka UI, kas vērsts uz Brave vairogiem`)
};

const lt_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimalistinė naršyklės UI, sutelkta į Brave Shields`)
};

const hu_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimalista böngésző UI a Brave Shields köré építve`)
};

const nl_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimalistische browser-UI met Brave Shields centraal`)
};

const nb_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimalistisk browser-UI sentrert rundt Brave Shields`)
};

const pl_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimalistyczny interfejs przeglądarki skoncentrowany na Tarczach Brave`)
};

const pt_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UI minimalista do navegador centrada nas Proteções Brave`)
};

const ro_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IU minimalistă a browser-ului centrată pe Brave Shields`)
};

const sk_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimalistické UI prehliadača zamerané na Štíty Brave`)
};

const sl_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimalistični uporabniški vmesnik brskalnika, osredotočen na Brave Ščite`)
};

const fi_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimalistinen selaimen käyttöliittymä, jonka keskiössä on Brave-suojaus`)
};

const sv_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimalistiskt webbläsar-UI centrerat kring Brave Shields`)
};

const vi_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao diện trình duyệt tối giản tập trung vào Lá chắn Brave`)
};

const tr_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Kalkanlar etrafında merkezlenmiş minimalist tarayıcı arayüzü`)
};

const el_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Μινιμαλιστικό UI προγράμματος περιήγησης επικεντρωμένο στις Ασπίδες Brave`)
};

const bg_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минималистичен браузър UI, фокусиран върху Brave защити`)
};

const ru_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минималистичный интерфейс браузера, ориентированный на Защиту Brave`)
};

const sr_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минималистички browser UI усмерен на Brave Shields`)
};

const uk_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мінімалістичний UI браузера, орієнтований на Щити Brave`)
};

const ka_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`მინიმალისტური ბრაუზერის UI Brave Shields-ზე ცენტრირებული`)
};

const hi_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Shields पर केंद्रित न्यूनतम ब्राउज़र UI`)
};

const th_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UI เบราว์เซอร์แบบเรียบง่ายที่เน้น Brave Shields`)
};

const ko_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave 쉴드를 중심으로 한 미니멀한 브라우저 UI`)
};

const zh_tw_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以 Brave 盾牌為核心的極簡瀏覽器 UI`)
};

const ja_origin_feature_2 = /** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brave Shields を中心としたミニマリストなブラウザ UI`)
};

/** @type {(inputs: Origin_Feature_2Inputs) => LocalizedString} */
const zh_origin_feature_2 = en_origin_feature_2;

/**
* | output |
* | --- |
* | "Minimalist browser UI centered on Brave Shields" |
*
* @param {Origin_Feature_2Inputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const origin_feature_2 = /** @type {((inputs?: Origin_Feature_2Inputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Origin_Feature_2Inputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_origin_feature_2(inputs)
	if (locale === "ms") return ms_origin_feature_2(inputs)
	if (locale === "ca") return ca_origin_feature_2(inputs)
	if (locale === "cs") return cs_origin_feature_2(inputs)
	if (locale === "da") return da_origin_feature_2(inputs)
	if (locale === "de") return de_origin_feature_2(inputs)
	if (locale === "et") return et_origin_feature_2(inputs)
	if (locale === "es") return es_origin_feature_2(inputs)
	if (locale === "fr") return fr_origin_feature_2(inputs)
	if (locale === "hr") return hr_origin_feature_2(inputs)
	if (locale === "it") return it_origin_feature_2(inputs)
	if (locale === "lv") return lv_origin_feature_2(inputs)
	if (locale === "lt") return lt_origin_feature_2(inputs)
	if (locale === "hu") return hu_origin_feature_2(inputs)
	if (locale === "nl") return nl_origin_feature_2(inputs)
	if (locale === "nb") return nb_origin_feature_2(inputs)
	if (locale === "pl") return pl_origin_feature_2(inputs)
	if (locale === "pt") return pt_origin_feature_2(inputs)
	if (locale === "ro") return ro_origin_feature_2(inputs)
	if (locale === "sk") return sk_origin_feature_2(inputs)
	if (locale === "sl") return sl_origin_feature_2(inputs)
	if (locale === "fi") return fi_origin_feature_2(inputs)
	if (locale === "sv") return sv_origin_feature_2(inputs)
	if (locale === "vi") return vi_origin_feature_2(inputs)
	if (locale === "tr") return tr_origin_feature_2(inputs)
	if (locale === "el") return el_origin_feature_2(inputs)
	if (locale === "bg") return bg_origin_feature_2(inputs)
	if (locale === "ru") return ru_origin_feature_2(inputs)
	if (locale === "sr") return sr_origin_feature_2(inputs)
	if (locale === "uk") return uk_origin_feature_2(inputs)
	if (locale === "ka") return ka_origin_feature_2(inputs)
	if (locale === "hi") return hi_origin_feature_2(inputs)
	if (locale === "th") return th_origin_feature_2(inputs)
	if (locale === "ko") return ko_origin_feature_2(inputs)
	if (locale === "zh") return zh_origin_feature_2(inputs)
	if (locale === "zh-tw") return zh_tw_origin_feature_2(inputs)
	if (locale === "ja") return ja_origin_feature_2(inputs)
	return en_origin_feature_2(inputs)
});